<div *ngIf="!currentEmployee.pendingLoanRequests.pending; else showPending">

  <div class="row py-5 mx-3  border-bottom">

    <div class="col-md-3">
      <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanStatementReport"
        [class.btn-outline-secondary]="!showLoanStatementReport" (click)="loanStatementReport()">
        Estado de Cuenta
      </button>
    </div>

    <div class="col-md-3">

      <div [matTooltip]="restucturedMessage" aria-label="mensaje" matTooltipPosition="above"
        [matTooltipDisabled]="!shouldAllowRestructuring(currentEmployee, loan)">

        <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanRestructuring" [class.btn-outline-secondary]="!showLoanRestructuring" (click)="loanRestructuring()" 
        [disabled]="shouldAllowRestructuring(currentEmployee, loan)" 
        [matBadgeHidden]="!shouldAllowRestructuring(currentEmployee, loan)" matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
          Reestructuración De Préstamo
        </button>

      </div>

    </div>

    <div class="col-md-3">

      <div matTooltip="Existe un candado en este momento por periodo de pagos, inténtelo mas tarde."
        aria-label="mensaje" matTooltipPosition="above"
        [matTooltipDisabled]="!logicService.isTodayAPayrollDayForEmployee(currentEmployee)">

        <button [ngClass]="'btn btn-block'" [class.btn-primary]="showLoanAdvancePayment"
          [class.btn-outline-secondary]="!showLoanAdvancePayment" (click)="loanAdvancePayment()"
          [disabled]="logicService.isTodayAPayrollDayForEmployee(currentEmployee)"
          [matBadgeHidden]="!logicService.isTodayAPayrollDayForEmployee(currentEmployee)" matBadge="?"
          matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
          Pago Anticipado De Préstamo
        </button>

      </div>

    </div>
    <div class="col-md-3">

      <div *ngIf="disabledBonus && this.bonusType.length > 0 ">

        <button [ngClass]="'btn btn-block'" [class.btn-primary]="showExtraAdvancePayment"
          [class.btn-outline-secondary]="!showExtraAdvancePayment" (click)="extraAdvancePayment()">
          Aportación Extraordinaria
        </button>

      </div>

    </div>

  </div>

  <div *ngIf="showLoanStatementReport">

    <h5 class="my-3">Datos Iniciales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Importe Inicial:" [value]="(loan.requestedAmount | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Intereses Cobrados:" [value]="(totalInterest | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>
    </div>

    <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal | number: '.2-2')"
            type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="number" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="mt-5 row">
      <div class="col-md-12">

        <table mat-table *ngIf="!loanType" [dataSource]="scheduleDatesValues" class="table border">

          <ng-container matColumnDef="depositDateBiWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Catorcena: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="depositDateWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Semana: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element"> {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedUpFrontColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedUpFrontColumns; let i = index"></tr>

        </table>

        <table mat-table *ngIf="loanType" [dataSource]="scheduleDatesValues" class="table border">

          <!-- depositDate Column -->
          <ng-container matColumnDef="biWeekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Catorcena </th>
            <td mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="weekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Semana </th>
            <td mat-cell *matCellDef="let element"> {{ element.weekNumber }} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef> Año </th>
            <td mat-cell *matCellDef="let element"> {{ element.depositDate | date:'yyyy'}} </td>
          </ng-container>

          <!-- capital Column -->
          <ng-container matColumnDef="capital">
            <th mat-header-cell *matHeaderCellDef> Capital </th>
            <td mat-cell *matCellDef="let element">$ {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="capitalAmortization">
            <th mat-header-cell *matHeaderCellDef> Capital Pendiente: </th>
            <td mat-cell *matCellDef="let element">$ {{element.capitalAmortization  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="interest">
            <th mat-header-cell *matHeaderCellDef> Intereses: </th>
            <td mat-cell *matCellDef="let element">$ {{element.interest  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element">$ {{element.total  | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedFixedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedFixedColumns; let i = index"></tr>

        </table>

      </div>
    </div>

    <div class="my-5 row">
      <div class="col-md-4 offset-md-8">
        <button class="btn btn-outline-secondary btn-block" (click)="cancelSimple(1, null)">Regresar</button>
      </div>
    </div>

  </div>

  <div class="mt-3" *ngIf="showLoanRestructuring">

    <h5 class="mt-1 mb-4">Datos Iniciales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Importe Inicial:" [value]="(loan.requestedAmount | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Intereses Cobrados:" [value]="(totalInterest | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha del Primer Descuento:"
            [value]="firstPaymentDate ? (firstPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal | number: '.2-2')"
            type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <!--div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Total a Recibir:" [value]="(remainderPayment | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha de Liquidación Via Nomina:" [value]="nextPaymentDate ? (nextPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>

    </div-->

    <h5 class="mb-4">Datos a Tomar en Cuenta para la Reestructuración:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Monto Máximo que puede solicitar en el Nuevo Préstamo:"
            [value]="(maxLoanAmount | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Acumulado Caja de Ahorro:" [value]="(savingsTotal | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Máximo de Cuotas para Descuento:" [value]="maxNumberOfPayments" type="number"
            disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input style="width:95%;" matInput placeholder="Factor de Interés:"
            [value]="loanInterest.toFixed(4)" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row" onpaste="return false">
      <div class="col-md-4">
        <mat-form-field>
          <span matPrefix>$&nbsp;</span>
          <input matInput placeholder="Monto del Préstamo a solicitar:" [(ngModel)]="newLoan.requestedAmount"
            type="number" min="0" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Cuotas a Descontar de la Nómina:"
            [(ngModel)]="newLoan.requestedNumberOfPayments" type="number" min="0"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
        </mat-form-field>
      </div>

      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.2-25em;" class="btn btn-block btn-primary "
          (click)="calculate()">Calcular</button>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Intereses Generados:" [value]="(newLoan.interestAmount | number: '.2-2')"
            type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Monto a Descontar:"
            [value]="discountPerPayment ? (discountPerPayment | number: '.2-2') : '0'" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row" *ngIf="newLoan.scheduleDates.values().length > 0">
      <div class="col-md-12">

        <table mat-table *ngIf="!newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <ng-container matColumnDef="depositDateBiWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Catorcena: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="depositDateWeek">
            <th mat-header-cell *matHeaderCellDef> Número De Semana: </th>
            <td mat-cell *matCellDef="let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element"> {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedUpFrontColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedUpFrontColumns; let i = index"></tr>

        </table>

        <table mat-table *ngIf="newLoanType" [dataSource]="newLoan.scheduleDates.values()" class="table border">

          <!-- depositDate Column -->
          <ng-container matColumnDef="biWeekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Catorcena </th>
            <td mat-cell *matCellDef="let element"> {{element.biWeekNumber}} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="weekNumber">
            <th mat-header-cell *matHeaderCellDef> Número Semana </th>
            <td mat-cell *matCellDef="let element"> {{ element.weekNumber }} </td>
          </ng-container>

          <!-- depositDate Column -->
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef> Año </th>
            <td mat-cell *matCellDef="let element"> {{ element.depositDate | date:'yyyy'}} </td>
          </ng-container>

          <!-- capital Column -->
          <ng-container matColumnDef="capital">
            <th mat-header-cell *matHeaderCellDef> Capital </th>
            <td mat-cell *matCellDef="let element">$ {{element.capital | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="capitalAmortization">
            <th mat-header-cell *matHeaderCellDef> Capital Pendiente: </th>
            <td mat-cell *matCellDef="let element">$ {{element.capitalAmortization  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="interest">
            <th mat-header-cell *matHeaderCellDef> Intereses: </th>
            <td mat-cell *matCellDef="let element">$ {{element.interest  | number: '.2-2'}} </td>
          </ng-container>

          <!-- totalAmount Column -->
          <ng-container matColumnDef="totalAmount">
            <th mat-header-cell *matHeaderCellDef> Total: </th>
            <td mat-cell *matCellDef="let element">$ {{element.total  | number: '.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="paid">
            <th mat-header-cell *matHeaderCellDef> Pagado: </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon>{{element.paid ? 'check' : 'alarm'}}</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedFixedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedFixedColumns; let i = index"></tr>

        </table>

      </div>
    </div>

    <div class="my-5 row">
      <div class="col-md-4 offset-md-4">

        <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
      </div>
      <div class="col-md-4">

        <button class="btn btn-block btn-primary" (click)="saveRestructuredLoan()"
          [disabled]="newLoan.scheduleDates.values().length == 0">Aceptar</button>
      </div>
    </div>

  </div>

  <div class="mt-3" *ngIf="showLoanAdvancePayment">

    <h5 class="mb-4">Datos Iniciales de su Préstamo:</h5>

    <div class="row">
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Importe Inicial:" [value]="(loan.requestedAmount | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>
    </div>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Cuotas Iniciales De Descuento:" [value]="loan.scheduleDates.values().length"
            type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Factor de Interés:"
            [value]="loan.interestPercentage.toFixed(4)" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div *ngIf="totalInterest > 0" class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Intereses Cobrados:" [value]="(totalInterest | number: '.2-2')" type="text"
            disabled>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha del Primer Descuento:"
            [value]="firstPaymentDate ? (firstPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal | number: '.2-2')"
            type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <!--div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Total a Recibir:" [value]="(remainderPayment | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha de Liquidación Via Nomina:" [value]="nextPaymentDate ? (nextPaymentDate | date : 'mediumDate') : ''" type="text" disabled>
        </mat-form-field>
      </div>
    </div-->

    <div class="row">
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-block btn-outline-primary" (click)="saveAdvanceLoanPayment()">Aceptar</button>
      </div>
    </div>

  </div>

  <div class="mt-3" *ngIf="showExtraAdvancePayment">
    <div *ngIf="!showExtraAdvancePaymentComplete ; else showBonusPending">
          
    <div class="alert alert-danger">
      En este apartado podras realizar una aportación porcentual de tu bono a tu préstamo activo. 
    </div>

    <h5 class="mb-4">Datos Actuales de su Préstamo:</h5>

    <div class="row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Amortizada:" [value]="(paidTotal | number: '.2-2')" type="text" disabled>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Suma Pendiente de Amortizar:" [value]="(pendingTotal | number: '.2-2')"
            type="text" disabled>
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Número de Pagos Restantes:" [value]="remainingPayments" type="text" disabled>
        </mat-form-field>
      </div>
    </div>
    <h5 class="mb-4">Aportación</h5>
    <div class="row" onpaste="return false">
      <div class="col-md-3"  >
        <mat-form-field>
          <mat-select placeholder="Tipo de Aportación:" (selectionChange)="selectedBonusTypeChange($event)" [value]="newBonusType">
            <mat-option>Seleccione el Tipo de Aportación</mat-option>
            <mat-option *ngFor="let type of bonusType"  [value]="type.id">
              {{type.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-3" *ngIf="permanentSavings !== null" >
        <mat-form-field>
          <input style="width:90%;" matInput placeholder="Porcentaje Aportacion Caja de Ahorro:" 
          [(ngModel)]="newBonusPercentage" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          (ngModelChange)="newBonusPercentage=bonusInputChanged($event)" [disabled]="disabledSaving">
          <span class="matPrefixDisabled" matSufix>%</span>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field>
          <input style="width:90%;" matInput placeholder="Porcentaje para Préstamo:" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          [(ngModel)]="newBonusInfo.percentage" type="number">
          <span class="matPrefixDisabled" matSufix>%</span>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-radio-group [(ngModel)]="newBonusInfo.type" >
          <mat-radio-button color="primary" class="example-margin" value="payments">Disminución de Tiempo</mat-radio-button>
          <mat-radio-button color="primary" class="example-margin" value="capital">Disminución de Importe</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-outline-secondary btn-block" (click)="cancel(1, null)">Cancelar</button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-block btn-outline-primary" (click)="saveBonusExtraAdvance()">Aceptar</button>
      </div>
    </div>
    </div>
  </div>
</div>

<ng-template #showPending>

  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Solicitud De Préstamo Caja De Ahorro Permanente</h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5>{{currentEmployee.pendingLoanRequests.reason}}</h5>
      <h4 *ngIf="loanListItem && loanListItem.listIndex > 0">{{loanListItem.listIndex.toString()}}</h4>
    </div>
  </div>
  <div class="my-5 row">
    <div class="col-md-4 offset-md-2" *ngIf="loanListActive && loanListItem && loanListItem.listIndex > 0">
      <button class="btn btn-outline-danger btn-block" (click)="cancelLoanPending(1, null)">Cancelar Solicitud</button>
    </div>
    <div class="col-md-4" [ngClass]="{'offset-md-4': !loanListActive || !loanListItem}">
      <button class="btn btn-outline-primary btn-block" (click)="cancelSimple(1, null)">Regresar</button>
    </div>
  </div>
</ng-template>

<ng-template #showBonusPending>
  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Su Solicitud Aportación Extraordinaria </h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5>Se ha realizado con exito.</h5>
      <h4 *ngIf="loanListItem && loanListItem.listIndex > 0">{{loanListItem.listIndex.toString()}}</h4>
    </div>
  </div>
</ng-template>
